import { setBranchSeoInfo } from 'api/branch/storage';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

const RouteChangeHandler = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const queryString = location.search;

  useEffect(() => {
    const query = queryString || '';

    setBranchSeoInfo({ url: `${window.location.origin}${pathname}${query}` });
  }, [pathname, queryString]);

  return null;
};

export default RouteChangeHandler;
